export default "__VITE_ASSET__288c31d0__"